import { SigmaContainer } from '@react-sigma/core';
import { Attributes, useContext, useEffect, useState } from 'react';
import { GraphViewContext } from './Index';
import {
  Node,
} from '@/lib/api/APITypes';
import { createEdgeArrowProgram } from 'sigma/rendering';
import Graph from 'graphology';
import GraphEvents from './Events';
import { incrementRefreshCounter, removeFloatingDoc } from '@/lib/state/slices/ProjectStateSlice';
import { copyToMutableGraph } from '@/lib/GraphFactory';
import { useDispatch } from 'react-redux';
import { NodeBorderProgram } from '@sigma/node-border';
import FloatingDocument from './FloatingDocument';
import NodeContextMenu from './controls/NodeContextMenu';
import TimeFilter from './controls/TimeFilter';

export default function TimeLineLayout(props: {
  loadNeighbours: Function;
  loadRecommendedNeighbours: Function;
}) {
  const dispatch = useDispatch();
  const graphView = useContext(GraphViewContext);
  const [graph, setGraph] = useState<Graph<Node, Attributes, Attributes>>(new Graph({ type: 'mixed' }));

  const [nodeContextMenu, setNodeContextMenu] = useState<{
    nodeId: string;
    id: string;
  }>();
  
  useEffect(() => {
    if (!graphView.serializedGraph) {
      console.error('Serialzied Graph is null. Not my job to load it.');
    } else {
      setGraph(
        copyToMutableGraph(
          Graph.from(graphView.serializedGraph) as Graph<Node, Attributes, Attributes>,
        ),
      );
      dispatch(incrementRefreshCounter());
    }
  }, [graphView.serializedGraph]);


  return (
    <SigmaContainer
      style={{ height: '100%', width: '100%', display: 'flex', position: 'relative' }}
      settings={{
        hoverRenderer: () => {},
        defaultEdgeType: 'arrow',
        edgeProgramClasses: {
          arrow: createEdgeArrowProgram({
            lengthToThicknessRatio: 6,
            widenessToThicknessRatio: 6,
          }),
        },
        nodeProgramClasses: {
          border: NodeBorderProgram,
        },
        zoomingRatio: 1.2,
        enableCameraRotation: false,
        allowInvalidContainer: true,
        renderEdgeLabels: false,
      }}
      key={`sigmaContainer${graphView.id}`}
      graph={graph}
    >
      <GraphEvents onHoverNode={() => {}} isActive={true} setNodeContextMenu={setNodeContextMenu} />
      {graphView.floatingDocuments.map((doc) => (
        <FloatingDocument
          elementId={doc.nodeId}
          key={doc.id}
          id={doc.id}
          onClose={() => {
            dispatch(
              removeFloatingDoc({
                graphViewId: graphView.id,
                floatingDocId: doc.id,
              }),
            );
          }}
        />
      ))}
      {/* <TimeFilter style={{ position: 'absolute', bottom: '20px', left: '2%' }} /> */}
      {nodeContextMenu ? (
        <NodeContextMenu
          id={nodeContextMenu.id}
          nodeId={nodeContextMenu.nodeId}
          key={nodeContextMenu.nodeId}
          loadNeighbours={(id: string) => {
            props.loadNeighbours({ id, level: 1 });
          }}
          recommendNeighbours={(id: string, nodeId: string) => {
            props.loadRecommendedNeighbours(id);
          }}
        />
      ) : null}
    </SigmaContainer>
  );
}
